var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClipboardTick = function SvgClipboardTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M27.067 6.083H12.933c-4.116 0-7.45 3.35-7.45 7.45v15.684c0 4.1 3.35 7.45 7.45 7.45H27.05c4.117 0 7.45-3.35 7.45-7.45V13.533c.017-4.116-3.333-7.45-7.433-7.45Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.917 3.333h-7.834c-1.733 0-3.15 1.4-3.15 3.134v1.566a3.13 3.13 0 0 0 3.134 3.134h7.85a3.13 3.13 0 0 0 3.133-3.134V6.467c.017-1.734-1.4-3.134-3.133-3.134ZM18.017 28.25c-.317 0-.634-.117-.884-.367l-2.5-2.5a1.257 1.257 0 0 1 0-1.766 1.257 1.257 0 0 1 1.767 0l1.617 1.616L23.8 19.45a1.258 1.258 0 0 1 1.767 0 1.258 1.258 0 0 1 0 1.767L18.9 27.883c-.233.25-.567.367-.883.367Z",
    fill: "currentColor"
  })));
};
export default SvgClipboardTick;